<template>
  <div id="content">
    <v-card>
      <v-responsive max-height="500">
        <v-img class="white--text" :src="banner" max-height="500">
          <v-layout fill-height justify-center align-center>
            <h1 class="banner-title">Ministries</h1>
          </v-layout>
        </v-img>
      </v-responsive>
    </v-card>
    <v-container grid-list-lg v-for="(section, i) in ministries" :key="i" class="text-xs-center">
      <v-divider class="grey" v-if="section.title"></v-divider>
      <h5 class="headline my-3" v-if="section.title">{{ section.title }}</h5>
      <p class="subheading" v-if="section.desc" v-html="section.desc"></p>
      <v-layout v-for="(ministry, i) in section.items" :key="i" justify-center align-center wrap>
        <v-flex xs12 sm8 md6 lg7>
          <v-card>
            <v-responsive :aspect-ratio="16/9">
              <v-img :src="ministry.img"></v-img>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 md6 lg5>
          <v-card flat>
            <!-- Title -->
            <v-card-title primary-title>
              <div class="flex">
                <div class="headline mb-2" v-html="ministry.title"></div>
                <span class="grey--text darken-3" v-html="ministry.desc"></span>
              </div>
            </v-card-title>

            <!-- Content -->
            <v-card-text v-if="ministry.content">
              <v-layout row wrap>
                <v-flex v-for="(content, index) in ministry.content" :key="index" xs3>
                  <v-icon v-if="content.icon">{{ content.icon }}</v-icon>
                  <div v-if="content.main">
                    <div>{{ content.main }}</div>
                    <div class="caption grey--text text-uppercase">{{ content.sub }}</div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions v-if="ministry.action" class="justify-center">
              <!-- Action -->
              <v-btn flat @click="ministry.show = !ministry.show">
                <span>{{ ministry.action }}</span>
                <v-icon>{{ ministry.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              </v-btn>
              <!-- Action 2 -->
              <v-btn flat v-if="ministry.action2" @click="ministry.show2 = !ministry.show2">
                <span>{{ ministry.action2 }}</span>
                <v-icon>{{ ministry.show2 ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <!-- Hidden Content -->
            <v-slide-y-transition v-if="ministry.hiddenContent || ministry.hiddenText">
              <v-card-text v-show="ministry.show">
                {{ ministry.hiddenText }}
                <v-layout row wrap>
                  <v-flex v-for="(content, index) in ministry.hiddenContent" :key="index" xs4>
                    <div>{{ content.main }}</div>
                    <div class="caption grey--text text-uppercase">{{ content.sub }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-slide-y-transition>

            <!-- Hidden Content 2 -->
            <v-slide-y-transition v-if="ministry.hiddenContent2 || ministry.hiddenText2">
              <v-card-text v-show="ministry.show2">{{ ministry.hiddenContent2 }}</v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Ministries",
  data() {
    return {
      banner: require("../assets/banner/ministries-banner.jpg"),
      ministries: [
        {
          title: "Sunday Worship Service",
          items: [
            {
              title: "UCC Kids",
              desc:
                "Come bring your kids to our Sunday School. Our age-appropriate curriculum teaches kids all about our Holy God through praise songs, story-telling, games, arts, and crafts every week.<br><strong>*PRIMARY Class - ages 3-8 years old</strong><br><strong>*JUNIOR Class - ages 9-12 years old</strong>",
              content: [
                {
                  icon: "access_time"
                },
                {
                  main: "Every Sunday"
                },
                {
                  main: "10:00AM",
                  sub: "Starts"
                },
                {
                  main: "11:30PM",
                  sub: "Ends"
                }
              ],
              img: require("../assets/ministries/childrens-ministry.jpg")
            },
            {
              title: "Music",
              desc:
                "We put importance in worshipping God with the use of music. It is our goal that the music focuses on drawing people to Him. The songs we sing glorify God and deepen our knowledge of Him.",
              img: require("@/assets/ministries/praise-and-worship.jpg")
            }
          ]
        },
        {
          title: "Fellowship Groups",
          desc: "Grow with us as we study the Word of God together.",
          items: [
            {
              title: "Wednesday In-Depth Bible Study",
              desc: "Valencia Hills Condominium, Quezon City",
              content: [
                {
                  icon: "access_time"
                },
                {
                  main: "7:30PM",
                  sub: "Dinner"
                },
                {
                  main: "8:30PM",
                  sub: "Bible Study"
                },
                {
                  main: "10:00PM",
                  sub: "Ends"
                }
              ],
              img: require("@/assets/ministries/in-depth-bible-study.jpg")
            },
            {
              title: "Friday 3:16 Fellowship",
              desc: "#16 Tinaduan St. Brgy. Masambong, Quezon City",
              content: [
                {
                  icon: "access_time"
                },
                {
                  main: "7:30PM",
                  sub: "Dinner"
                },
                {
                  main: "8:30PM",
                  sub: "Bible Study"
                },
                {
                  main: "10:00PM",
                  sub: "Ends"
                }
              ],
              img: require("@/assets/ministries/bible-enrichment-fellowship.jpg")
            }
          ]
        },
        // {
        //   title: "Missions",
        //   desc:
        //     '<h6 class="title">About ELI Asia</h6><p class="subheading">Evangelical Leadership Institute Asia (ELI Asia) seeks to enable Christian leaders to acquire theological and ministerial education equivalents to those offered in Bible colleges, without leaving their churches for a long time.</p>',
        //   items: [
        //     {
        //       title: "Advancing Ministerial Training",
        //       desc:
        //         "ELI Asia exists to serve and function as the theologoical education and training arm of the local church. It comes alongside churches to develop pastors and Christian leaders so they can effectively shepherd their congregations and equip them to make disciples for Christ.",
        //       img: require("@/assets/ministries/mens-leadership-class.jpg"),
        //       hiddenText:
        //         "CAMPUSES Since 2012, we have established the campuses in the following local churches.",
        //       hiddenContent: [
        //         {
        //           main: "Siniloan Baptist Church",
        //           sub: "Siniloan, Laguna"
        //         },
        //         {
        //           main: "Christo Centric Baptist Church",
        //           sub: "San Jose Del Monte, Bulacan"
        //         },
        //         {
        //           main: "Community Baptist Church of Calamba",
        //           sub: "Calamba, Laguna"
        //         },
        //         {
        //           main: "Fabe Residence",
        //           sub: "Masantol, Pampanga"
        //         },
        //         {
        //           main: "The Lord Reigns Christian Church",
        //           sub: "San Pedro, Laguna"
        //         },
        //         {
        //           main: "Bagong Bayan Christian Church",
        //           sub: "Dasmarinas, Cavite"
        //         }
        //       ],
        //       action: "Show Campuses",
        //       show: false
        //     },
        //     {
        //       title: "Support ELI Asia",
        //       desc:
        //         'Consider partnering with us financially.<div class="caption">Send support online at <a href="https://www.worldmin.org">www.worldmin.org</a> or specifically through this link <a href="https://www.egsnetwork.com/gift2/?giftid=E047DE00D3F04D8#.">https://www.egsnetwork.com/gift2/?giftid=E047DE00D3F04D8#</a>. World Ministries would issue you a tax deductible receipt.</div>',
        //       img: require("@/assets/ministries/member-care.jpg"),
        //       hiddenText:
        //         "You may deposit your financial gifts to the following.",
        //       hiddenContent: [
        //         {
        //           main: "Triune Biblical Asia",
        //           sub: "Account Name"
        //         },
        //         {
        //           main: "BPI Family Savings Bank (Better Living Branch)",
        //           sub: "Bank"
        //         },
        //         {
        //           main: "Savings Account #6253-1824-05",
        //           sub: "Account Number"
        //         }
        //       ],
        //       hiddenContent2:
        //         "You may send your cheques to World Ministries P.O. Box 491656 Leesburg, Florida 34749-1656. Kindly write the designation for your gift in the memo of your cheque (i.e. ELI Asia)",
        //       action: "For PH Donors",
        //       action2: "For US Donors",
        //       show: false,
        //       show2: false
        //     }
        //   ]
        // }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Ministries.vue